{
  "typeOfProperty": {
    "title": "Real Estate Financing",
    "subtitle": "compare directly online",
    "question": "What would you like to buy?",
    "apartment": "Apartment",
    "singleFamilyHouse": "Single-family house",
    "apartmentBuilding": "Multi-family house",
    "landPlot": "Land plot"
  },
  "postalCode": {
    "title": "Where is the property you want to buy located?",
    "description": "In certain areas, banks offer particularly attractive conditions. By providing the postal code, we can also display these offers.",
    "label": "Property postal code",
    "placeholder": "e.g. 85774",
    "required": "Please enter a postal code",
    "invalid": "Please enter a valid postal code"
  },
  "purchasePrice": {
    "title": "What is the purchase price?",
    "description": "Please enter the pure purchase price below without additional costs.",
    "label": "Purchase price",
    "placeholder": "e.g. 350,000",
    "required": "Please enter the purchase price"
  },
  "equity": {
    "title": "How much equity do you want to contribute?",
    "description": "Ideally, you should contribute around 20% of the purchase price as equity to get a good interest rate. In some cases, it also works with less or none at all.",
    "label": "Equity to be used",
    "placeholder": "e.g. 75,000",
    "required": "Please enter your equity",
    "sellPropertyQuestion": "Are you also planning to sell a property in parallel?"
  },
  "monthlyNetIncome": {
    "title": "What is your monthly income?",
    "description": "This refers to the regular household net income of all household members. This information is needed by banks (anonymously) for the first condition inquiry.",
    "label": "Monthly household net income",
    "placeholder": "e.g. 4,500",
    "required": "Please enter your monthly household net income"
  },
  "contact": {
    "title": "Last step to your personal financing comparison",
    "firstName": "First name",
    "lastName": "Last name",
    "email": "Email",
    "phone": "Phone number",
    "firstNameRequired": "Please enter your first name",
    "lastNameRequired": "Please enter your last name",
    "emailRequired": "Please enter your email address",
    "emailInvalid": "Please enter a valid email address",
    "phoneRequired": "Please enter your phone number",
    "phoneInvalid": "Please enter a valid phone number",
    "error": "Unfortunately, an error occurred. Please try again.",
    "back": "Back",
    "continue": "Continue"
  },
  "offers": {
    "title": "Personal financing proposals",
    "purchasePrice": "Purchase price",
    "equity": "Equity",
    "monthlyNetIncome": "Monthly household net income",
    "changeDetails": "Change details",
    "noResultsTitle": "Unfortunately, we cannot find any results",
    "noResultsDescription": "Your equity share is probably too low. You can also try changing your entries or use the help of our experts.",
    "or": "or",
    "bookFreeConsultation": "Book free consultation",
    "loadingMessage": "We are requesting current real-time conditions from banks and savings banks. This may take a moment.",
    "reserveInterestRate": "Reserve interest rate",
    "discoverMoreOffers": "Discover more offers",
    "bookAppointment": "Book appointment online"
  },
  "interestRateModal": {
    "errorTitle": "Unfortunately, an error occurred",
    "errorMessage": "Unfortunately, an error occurred. Please try again.",
    "backToResults": "Back to results",
    "thankYouTitle": "Thank you",
    "thankYouMessage": "You will receive a confirmation of the interest rate reservation by email shortly.",
    "title": "Non-binding interest rate reservation",
    "description": "For most banks, we can reserve the interest rate for 2 days - for some even longer. This is completely free and non-binding for you.",
    "confirmReserve": "Yes, reserve interest rate"
  },
  "common": {
    "back": "Back",
    "continue": "Continue",
    "step": "Step",
    "of": "of",
    "results": "Results"
  }
}
